import script from "./CoreUiChatHistoryNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryNotification.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryNotification.vue?vue&type=style&index=0&id=51d5a954&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d5a954"]])

export default __exports__